import { Component, OnInit, OnChanges, Input, Inject } from '@angular/core';
import { UiService } from 'src/app/services/ui.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { EntityCalendarQueryType } from 'globals/store/public.model';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';

@Component({
    selector: 'calendar-subscription-dialog',
    template: ` 
    <div class="calsubdialog">
      <div class="top">
        <tip-text *ngIf="!!data.notPublishedMessage" [head]="'Note:'" [body]="data.notPublishedMessage"></tip-text>
        <icon icon="close" class="close" (click)="dialogRef.close()"></icon>       
      </div>
      <h3 class="more_space">Subscribe to calendar</h3>
      <div>Copy this URL to add it to your calendar client.</div>
      <div class="shareable_url">{{v1}}subscribe/{{entityType}}/{{eventId}}/{{entityId}}/{{shareCode}}</div>
      <div class="secondary_link right"><a href="https://academy.joi.events/how-to-subscribe-to-a-joi-calendar" target="_blank">Help</a></div>
      <div class="note">Note: some calendar clients fetch new data more frequently than others. <a href="https://academy.joi.events/why-isn't-my-calendar-feed-updating" class="secondary_link" target="_blank">Learn more &rsaquo;</a> </div>
      <button class="right" color="primary" mat-button (click)="copyTextToClipboard(v1+'subscribe/'+entityType+'/'+eventId+'/'+entityId+'/'+shareCode)">{{ copyState ? copied : copyUrl }}</button>
    </div>
  `,
    styleUrls: ['share.page.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, TipTextComponent],
})


export class CalendarSubscriptionDialogComponent implements OnInit {
  shareCode
  eventId: string;
  entityId: string
  entityType: EntityCalendarQueryType;
  copyUrl = 'Copy URL';
  copied = 'Copied'
  copyState = false;
  readonly v1 = `${environment.functionsURL}api/`;

  constructor(
    public dialogRef:MatDialogRef<CalendarSubscriptionDialogComponent>,
    public uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data:CalSubscriptionData,
  ) {
    this.eventId = data.eventId
    this.entityId = data.entityId
    this.entityType = data.entityType
    this.shareCode = data.shareCode
  }

  ngOnInit() {
    // let { x, y } = this.data
    // // console.log({ x, y })
    // if (y && document.body.clientHeight - y < 400) {
    //   y = Math.max(1, document.body.clientHeight - 400);
    // }
    // // console.log({ x, y })
    // if (x && y) this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
  }


  copyTextToClipboard(text: string) {
    navigator['clipboard'].writeText(text);
    this.copyState = true;
  }


}

export interface CalSubscriptionData {
  x?: number
  y?: number
  shareCode?: string
  eventId: string;
  entityId: string
  notPublishedMessage?: string
  entityType: EntityCalendarQueryType
  title?: string
  color?: string
}


